import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { PaperArrastavel } from "app/components/dialog-arrastavel/PaperArrastavel";
import React, { useEffect, useState } from "react";
import globalMU from "globalMU";
import { useFormik } from "formik";
import { DadosEncomenda } from "./DadosEncomenda";
import clsx from "clsx";
import { TooltipMU } from "app/components/tooltip/TooltipMU";
const estiloFormulario = require('../../../estilos/formulario.module.scss').default
const estiloBotoes = require('../../../estilos/botoes.module.scss').default

export type ModalVendaSobEncomendaProps = {
  onFecharCaixaDeDialogo: () => void;
  onCancelarCaixaDeDialogo: () => void;
  onAplicar: (adquirirQuantidadeTotal: boolean) => void
  processando: boolean
  dados: DadosEncomenda;
  habilitarAdquirirQuantidadeTotalItem: boolean;
  numeroCasasDecimaisQuantidade: number
};

export const ModalVendaSobEncomenda = (props: ModalVendaSobEncomendaProps) => {

  const [adquirirQuantidadeTotalItem, setAdquirirQuantidadeTotalItem] = useState(props.dados.AdquirirQuantidadeTotal)

  const dialogContentNovo = () => {

    const produto = <>
      <label>Produto</label>
      <span>{props.dados.Produto}</span>
    </>

    const quantidade = <>
      <label>Quantidade</label>
      <span>{globalMU.formatarValorNumerico(props.dados.Quantidade, props.numeroCasasDecimaisQuantidade)}</span>
    </>

    const quantidadeEmEstoque = <>
      <label>Quantidade em Estoque</label>
      <span>{globalMU.formatarValorNumerico(props.dados.QuantidadeEstoque, props.numeroCasasDecimaisQuantidade)}</span>
    </>

    const quantidadeReservada = <>
      <label>Quantidade Reservada</label>
      <span>{globalMU.formatarValorNumerico(props.dados.QuantidadeReservada, props.numeroCasasDecimaisQuantidade)}</span>
    </>

    
    const quantidadeJaReservadaNestePedido = <>
      <label>Quantidade Já Reservada Neste Pedido</label>
      <span>{globalMU.formatarValorNumerico(props.dados.QuantidadeReservadaPedido, props.numeroCasasDecimaisQuantidade)}</span>
    </>

    
    const quantidadeDisponivelNestePedido = <>
      <label>Quantidade Disponível Neste Pedido</label>
      <span>{globalMU.formatarValorNumerico(props.dados.QuantidadeDisponivelPedido, props.numeroCasasDecimaisQuantidade)}</span>
    </>

    
    const quantidadeEmPedidosCompra = <>
      <label>Quantidade em Pedidos de Compra</label>
      <span>{globalMU.formatarValorNumerico(props.dados.QuantidadePedidosCompra, props.numeroCasasDecimaisQuantidade)}</span>
    </>

    
    const prazoEntregaFornecedor = <>
      <label>Prazo de Entrega do Fornecedor (Dias)</label>
      <span>{props.dados.PrazoEntregaFornecedor}</span>
    </>

    
    const adquirirQuantidadeTotalItemComponent = <>
      <label htmlFor="ModalVendaSobEncomenda_checkboxAdquirirQuantidadeTotal" style={{cursor:'pointer'}}>Adquirir a Quantidade Total do Item</label>
      <div>
        <input 
          type="checkbox"
          id="ModalVendaSobEncomenda_checkboxAdquirirQuantidadeTotal"
          disabled={props.processando || !props.habilitarAdquirirQuantidadeTotalItem} // 444764
          checked={adquirirQuantidadeTotalItem ?? false}
          onChange={() => setAdquirirQuantidadeTotalItem(!adquirirQuantidadeTotalItem)}
          />
      </div>
    </>

  

    return <DialogContent>
      <div className={estiloFormulario.gridDuasColunas}>

        {produto}

        {quantidade}

        {quantidadeEmEstoque}

        {quantidadeReservada}

        {quantidadeJaReservadaNestePedido}

        {quantidadeDisponivelNestePedido}

        {quantidadeEmPedidosCompra}

        {prazoEntregaFornecedor}

        {adquirirQuantidadeTotalItemComponent}
        
      </div>
    </DialogContent>
  }

  const dialogActions = () => {

    const ok = <>
      <button
        id="ModalVendaSobEncomenda_BotaoOk"
        title="Aplica as alterações no item do pedido"
        disabled={props.processando}
        className={clsx(estiloBotoes.botaoPrimario, 'no-global-button')}
        onClick={() => {
          props.onAplicar(adquirirQuantidadeTotalItem)
          
        }}
      >
        Ok
      </button>
    </>

    const cancelar = <>
      <TooltipMU title="Retira o item da encomenda">
      <span>
      <button
        id="ModalVendaSobEncomenda_BotaoCancelar"
        title="Retira o item da encomenda"
        disabled={props.processando}
        className={clsx(estiloBotoes.botaoPrimario, 'no-global-button')}
        onClick={props.onCancelarCaixaDeDialogo}
      >
        Cancelar
      </button>
      </span>
      </TooltipMU>
    </>

  const fechar = <>
  <TooltipMU title="Fecha sem modificar a encomenda do item">
  <span>
  <button
    id="ModalVendaSobEncomenda_BotaoFechar"
    disabled={props.processando}
    title="Fecha a caixa de diálogo sem alterar a encomenda"
    className={clsx(estiloBotoes.botaoPrimario, 'no-global-button')}
    onClick={props.onFecharCaixaDeDialogo}
  >
    Fechar
  </button>
  </span>
  </TooltipMU>
  </>

    return <>
      <DialogActions>
          {(!props.dados.EncomendaAutomatica || props.habilitarAdquirirQuantidadeTotalItem) // 444764
            && ok}
          {!props.dados.EncomendaAutomatica && cancelar}
          {fechar}  {/* 444764 */}
      </DialogActions>
    </>
  }

  return (
    <>
      <Dialog
        id="ModalVendaSobEncomenda_Dialog"
        fullWidth={true}
        maxWidth="md"
        open={true}
        scroll="paper"
        PaperComponent={PaperArrastavel}>

          <DialogTitle>
            Venda Sob Encomenda
            <IconButton className="_float-right" onClick={props.onFecharCaixaDeDialogo}>
              x
            </IconButton>
          </DialogTitle>

        {dialogContentNovo()}

        {dialogActions()}

      </Dialog>
    </>
  );
};
